import React from "react";

export default function InfoIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
  <g id="Gruppe_290" data-name="Gruppe 290" transform="translate(-512 -1869)">
    <path id="Pfad_1269" data-name="Pfad 1269" d="M1.162-7H2.744V0H1.162Zm.8-1.064a.989.989,0,0,1-.728-.294.956.956,0,0,1-.294-.7.989.989,0,0,1,.294-.728.989.989,0,0,1,.728-.294.972.972,0,0,1,.714.294.989.989,0,0,1,.294.728.956.956,0,0,1-.294.7A.972.972,0,0,1,1.96-8.064Z" transform="translate(520.547 1884.54)" fill="currentColor"/>
    <g id="Ellipse_101" data-name="Ellipse 101" transform="translate(512 1869)" fill="none" stroke="currentColor" strokeWidth="1">
      <circle cx="10.5" cy="10.5" r="10.5" stroke="none"/>
      <circle cx="10.5" cy="10.5" r="10" fill="none"/>
    </g>
  </g>
</svg>;
}